import Section from "../Section";
import QuickAdd from '../global/QuickAdd';

export default class ShopTheLook extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.attachEvents();

    Array.prototype.forEach.call(
      element.querySelectorAll('.quick-add-button-variants'),
      (shopNow) => {
        if (shopNow) {
          shopNow.addEventListener('click', this.handleShopNow);
        }
      },
    );
    this.quickAddButtons = new QuickAdd(window.wetheme, element);
    this.theme.addBadges(this.element, 1000);
  }

  attachEvents() {
    // The css transform applied by the global fadeInUp animation breaks the fixed positioning of the section modal, so we need to remove it once the animation is complete
    this.element.addEventListener('animationend', (e) => {
      if (e.animationName === 'fadeIn') {
        this.element.classList.remove('fadeIn');
      }
    });
  }

  handleShopNow = (e) => {
    e.preventDefault();
    window.wetheme.toggleRightDrawer('shop-now', true, { url: e.currentTarget.href });
  }
}
